const state = {
  broadcastList: [],
  broadcastCancel: {
    dialog: false,
    broadcastListId: null,
  },
  broadcastWhatsAppTemplate: {
    dialog: false,
    routeType: null,
    routeNumber: null,
  },
  showCreateNewBroadcast: {
    dialog: false,
    templateMessageSelected: null,
    contactsSelected: [],
  },
  showBroadcastContactList: {
    dialog: false,
    broadcastListId: null,
  },
};

export default state;
